import React, { useRef, useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react';
import BottomSheet from './BottomSheet';
import { urlToFunnel } from '../utils/external';

export default function QrFullscreenModal({ open, onClose, restaurant }) {
  const containerRef = useRef(null);
  const [toast, setToast] = useState(null);

  if (!restaurant?.slug) {
    return <BottomSheet open={open} onClose={onClose} title="QR Code" height="auto" />;
  }
  const url = urlToFunnel(restaurant.slug);

  const handleDownload = () => {
    try {
      const canvas = containerRef.current?.querySelector('canvas');
      if (!canvas) {
        setToast('❌ Impossible de générer l\'image');
        return;
      }
      const dataUrl = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = `revyo-qr-${restaurant.slug}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setToast('✅ QR Code téléchargé');
      setTimeout(() => setToast(null), 2000);
    } catch (e) {
      setToast('❌ Erreur de téléchargement');
    }
  };

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: restaurant.nom || 'Revyo', text: 'Laissez-nous votre avis', url });
      } catch (_) {}
      return;
    }
    try {
      await navigator.clipboard.writeText(url);
      setToast('✅ Lien copié');
      setTimeout(() => setToast(null), 2000);
    } catch (_) {
      setToast('❌ Impossible de partager');
    }
  };

  return (
    <BottomSheet open={open} onClose={onClose} title="Mon QR Code" height="full">
      <div style={styles.container}>
        <div ref={containerRef} style={styles.qrWrap}>
          <QRCodeCanvas
            value={url}
            size={260}
            bgColor="#FFFFFF"
            fgColor="#1A1A1A"
            level="M"
            includeMargin={false}
          />
        </div>
        <p style={styles.url}>{url}</p>
        <div style={styles.actions}>
          <button type="button" onClick={handleDownload} style={styles.primary}>
            Télécharger PNG
          </button>
          <button type="button" onClick={handleShare} style={styles.secondary}>
            Partager le lien
          </button>
        </div>
        {toast && <div style={styles.toast}>{toast}</div>}
        <p style={styles.hint}>Imprimez ce QR sur vos tables ou sur l'addition pour collecter des avis.</p>
      </div>
    </BottomSheet>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
    paddingTop: 12,
  },
  qrWrap: {
    background: '#FFFFFF',
    padding: 16,
    borderRadius: 16,
    border: '1px solid #EDEAE3',
  },
  url: {
    margin: 0,
    fontSize: 13,
    color: '#1A1A1A',
    fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    textAlign: 'center',
    wordBreak: 'break-all',
  },
  actions: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    width: '100%',
    maxWidth: 340,
  },
  primary: {
    background: '#E8502A',
    color: '#FFFFFF',
    border: 'none',
    borderRadius: 12,
    padding: '14px 16px',
    fontSize: 15,
    fontWeight: 700,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  secondary: {
    background: '#FFFFFF',
    color: '#1A1A1A',
    border: '1px solid #E5E5E0',
    borderRadius: 12,
    padding: '14px 16px',
    fontSize: 15,
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit',
  },
  toast: {
    background: '#E8F5EE',
    color: '#2D7A4A',
    fontSize: 13,
    fontWeight: 600,
    padding: '8px 14px',
    borderRadius: 999,
  },
  hint: {
    margin: 0,
    fontSize: 12,
    color: '#6B6B6B',
    textAlign: 'center',
    maxWidth: 280,
    lineHeight: 1.4,
  },
};
